import { render, staticRenderFns } from "./Numeraciones.vue?vue&type=template&id=f78c0380"
import script from "./Numeraciones.vue?vue&type=script&lang=js"
export * from "./Numeraciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports